import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { StatePersistService } from '../services/state-persist.service';
import { AuthLoginService } from '../../user/services/auth-login.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HeaderInterceptors implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private authLoginService: AuthLoginService,
    private stateService: StatePersistService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request: any;
    let currentUser: any = this.stateService.getLocalStorage('currentUser') || '';

    let  publicTokenDetails: any = this.stateService.getLocalStorage('user_access_token') || '';
    if (publicTokenDetails && publicTokenDetails.includes('{')){
      publicTokenDetails = JSON.parse(publicTokenDetails)
    }

    let token = (currentUser && currentUser != 'undefined') ? currentUser.tokens?.access_token : publicTokenDetails.access_token;

    token = (token && token != 'undefined') ? token :  publicTokenDetails;
    
    if (req.url.indexOf('api/v3/o/token') === -1 && !req.url.includes('s3.amazonaws.com')) {

      req = req.clone({
        headers: new HttpHeaders({
          'Authorization': `Bearer ${token}`,
        })
      });
    }
    
   
    this.authService.isLoggedIn.subscribe(res => {
      if (!req.headers.has('Content-Type')) {
        request = req.clone({ headers: req.headers.set('Content-Type', 'application/json') });
      }
      if (!currentUser && req.url.indexOf('api-eu-central-1.graphcms.com') < 0) {
        if (!token){
          request = req.clone({ headers: req.headers.set('Content-Type', 'application/x-www-form-urlencoded') });
          request = req.clone({ headers: req.headers.set('Accept', 'application/json') });
          request = req.clone({ headers: req.headers.set('Cache-Control', 'no-cache') });
        }
        else{

          request = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
        }
        
      }

      if (currentUser && req.url.indexOf('api.ipify.org') < 0
        && req.url.indexOf('jsonip.com') < 0 && req.url.indexOf('api-eu-central-1.graphcms.com') < 0 && !req.url.includes('s3.amazonaws.com')) {
    
        request = req.clone({ setHeaders: { Authorization: `Bearer ${currentUser.tokens?.access_token}` } });
        request = request.clone({ setHeaders: { token: `${currentUser.encrpt_email}` } });
        request = request.clone({ setHeaders: { 'PLATFORM-TYPE': `${currentUser.platform_type}` } });
        // 3; this is for Magento logs, 3 device type means web
        request = request.clone({ setHeaders: { 'DEVICE-TYPE': '3' } });
        request = request.clone({ setHeaders: { 'EVENT-NAME': `${window.location.pathname}` } });
        
      }
      if (req.headers.has('IsImages')) {

        request = req.clone({ headers: req.headers.delete('IsImages') });
      }

      if(req.url.includes('api-eu-central-1.graphcms.com')){

        request = req.clone({ setHeaders: { Authorization: `Bearer ${environment.qraphapiToken}` } });
      }

      if(req.url.includes('refresh-token/')){

        request = req.clone({ setHeaders: { Authorization: `Bearer ${currentUser?.access_token}` } });
      }

    });
    return next.handle(request);
  }

}
